export const chartNameIDMap = {
  "viz-populationbyageandsexMale": "Population by Age & Sex",
  "viz-populationbyageandsexFemale": "Population by Age & Sex",
  "viz-race": "Population by Race",
  "viz-birthyearnote": "Population by Year of Birth",
  "viz-ethnicity": "Population by Ethnicity",
  "viz-ageatfirstobservation": "Age at First Observation",
  "viz-agebysex": "Age at First Observation by Sex",
  "viz-cumulativeobservation": "Cumulative Observation",
  "viz-observationbymonth": "Observation over Time",
  "viz-observationbyage": "Years of Observation by Age",
  "viz-observationbysex": "Years of Observation By Sex",
  "viz-populationAgeSexPerson": "Population By Age and Sex",
  "viz-ageatdeath": "Age at Death",
  "viz-deathbytype": "Death by Type",
  "viz-recordproportionbyagesexyear":
    "Record Count Proportion By Age, Sex, Year",
  "viz-deathrecordproportionbymonth": "Record Count Proportion by Month",
  "viz-densityOverview": "Domain Density",
  "viz-recordsperperson": "Domain Records per Person",
  "viz-beforeIndex": "observation time (days) prior to index",
  "viz-afterIndex": "observation time (days) after index",
  "viz-between": "time (days) between cohort start and end",
  "viz-recordproportionbymonth": "Record Count Proportion by Month",
  "viz-dataqualityresults": "Historical Data Quality",
  "viz-sourcedataqualityresultsbycategory":
    "Historical Data Quality by Category",
  "viz-sourcedataqualityresultsbydomain": "Historical Data Quality by Domain",
  issues_releases: "Data Quality Issues History",
  population_releases: "Population History",
  "viz-sourcerecordproportionbymonth": "Record Proportion by Month",
  "viz-costtime": "Cost Time Series",
};
